import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

/**
 * Alshallal switch — HeroUI style.
 * Longer track (h-6/w-11), off-state uses a soft neutral, on-state uses brand
 * orange. Thumb has a soft shadow and animates smoothly.
 */
const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full",
      "transition-colors duration-200 focus-visible:outline-none",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-[color:var(--brand-orange)]",
      "data-[state=unchecked]:bg-[color:var(--border-strong)]",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-white",
        "shadow-[0_2px_4px_rgba(31,28,26,0.15),0_1px_2px_rgba(31,28,26,0.10)]",
        "transition-transform duration-200 ease-out",
        "data-[state=checked]:translate-x-[22px] data-[state=unchecked]:translate-x-0.5"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
